import {getCurrentYear} from '../../utils/commons'
import BestHomeFixPicksLogo from './logo'
import {bestHomeFixPicksStylesUS} from './styles'

const baseConfig = {
  domainName: 'besthomefixpicks' as const,
  domainType: 'picks' as const,
  camelCaseUrl: 'BestHomeFixPicks.com',
  siteName: 'Best Home Fix Picks',
  logo: <BestHomeFixPicksLogo className="size-10 shrink-0 tablet:size-8" />,
  favicon: '/favicons/besthomefixpicks.png',
  styles: bestHomeFixPicksStylesUS,
}

const localeConfigs = {
  us: {
    measurementId: 'G-YSZSLGGLPH',
    title: (category: string, count: string) =>
      `Top ${count} ${category} ${getCurrentYear()} in the US | BestHomeFixPicks.com – Reviews & Pro Insights`,
    description: (_category?: string, _count?: string) =>
      `Find the best home essentials with expert reviews and comparisons. Upgrade your home with trusted picks for comfort, efficiency, and style.`,
  },
}

export const createConfig = (locale: string = 'us') => {
  const localeConfig = localeConfigs[locale as keyof typeof localeConfigs] || localeConfigs.us
  return {
    ...baseConfig,
    ...localeConfig,
  }
}
